import {
  Directive,
  ElementRef,
  Host,
  HostBinding,
  HostListener,
} from '@angular/core';

/*
   Made by u/doom777
   Published on https://github.com/doom777/angular-horizontal-mousewheel
 */

@Directive({
  selector: '[appHorizontalScroll]',
})
export class HorizontalScrollDirective {
  private nativeElement: HTMLElement;
  @HostBinding('scrollLeft') private scrollLeft;

  constructor(@Host() element: ElementRef) {
    this.nativeElement = element.nativeElement;
  }

  @HostListener('wheel', ['$event']) wheelTurned(wheelEvent: WheelEvent) {
    if (wheelEvent.deltaY) {
      this.scrollLeft = this.nativeElement.scrollLeft + wheelEvent.deltaY;
      wheelEvent.preventDefault();
    }
  }
}
